import { collection, onSnapshot, query } from "firebase/firestore";
import { createContext, useContext, useEffect, useState } from "react";
import { db } from "../firebase";

const pendingListContext = createContext();

export function PendingListContextProvider({children}){
    const [countPendingList, setPendingList] = useState(0);

    useEffect(()=>{
        const qu = query(collection(db,"pendingBooks"))
        const unsubsribe = onSnapshot(qu,(querySnapshot)=>{
            setPendingList(querySnapshot.size)
        })
        return () => {
            unsubsribe()
        }
    },[])

    return (
        <pendingListContext.Provider value={{countPendingList}}>
            {children}
        </pendingListContext.Provider>
    )
}

export function usePendingListCount(){
    return useContext(pendingListContext)
}
